import React, { useEffect, useState } from "react";
import Helmet from "react-helmet";
import { useStaticQuery, graphql } from "gatsby";
import moment from "moment";
import { useLocation } from "@reach/router";

const SEO = ({
  title,
  description,
  keywords,
  slug,
  createdAt,
  modifiedAt,
  banner,
  author,
  genre,
  wordCount,
  scehema,
}) => {

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const UpdatreshareId = params.get("share-id");
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          description
          siteUrl
        }
      }
    }
  `);


  const ldJson = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: title || data.site.siteMetadata.title,
    description: description || data.site.siteMetadata.description,
    logo: {
      "@type": "ImageObject",
      url: "https://tomedes.gumlet.io/frontend/images/tomedes-logo.jpg",
    },
  };

  const ldJosnBreadcrumbs = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        item: {
          "@id": "https://www.tomedes.com/",
          name: "Tomedes",
        },
      },
      {
        "@type": "ListItem",
        position: 2,
        item: {
          "@id": "https://www.tomedes.com/translator-hub.php",
          name: "Translators' Hub",
        },
      },
      {
        "@type": "ListItem",
        position: 3,
        item: {
          "@id": `${data.site.siteMetadata.siteUrl}${
            slug?.endsWith("/") ? slug?.slice(0, -1) : slug || ""
          }`,
          name: title,
        },
      },
    ],
  };


  const ldjsonInterpreting = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": "https://www.tomedes.com#organization",
        name: "Tomedes",
        url: "https://www.tomedes.com",
        logo: "https://tomedes.gumlet.io/frontend/images/tomedes-logo.jpg",
        sameAs: [
          "https://www.facebook.com/Tomedes.Translations",
          "https://twitter.com/Tomedes",
          "https://www.linkedin.com/company/tomedes/",
          "https://www.instagram.com/tomedes_translations/",
        ],
        contactPoint: [
          {
            "@type": "ContactPoint",
            contactType: "customer service",
            telephone: "+1-985-239-0142",
            email: "support@tomedes.com",
            areaServed: "US",
            availableLanguage: ["English"],
          },
        ],
        address: {
          "@type": "PostalAddress",
          addressLocality: "Beaverton",
          addressRegion: "Oregon",
          addressCountry: "USA",
          postalCode: "97008",
          streetAddress: "9450 SW Gemini Dr #34540",
        },
        aggregateRating: {
          "@type": "AggregateRating",
          ratingValue: "4.9",
          ratingCount: "1798",
          bestRating: "5",
          worstRating: "1",
        },
      },
      {
        "@type": "Service",
        "@id": "https://www.tomedes.com/interpretation-services#service",
        serviceType: "Professional Interpretation Services - Tomedes",
        provider: {
          "@id": "https://www.tomedes.com#organization",
        },
        areaServed: {
          "@type": "Place",
          name: "Global",
        },
        url: "https://www.tomedes.com/interpretation-services",
        description:
          "Tomedes provides professional interpretation services, including consecutive and simultaneous interpreting for business, legal, medical, and other industries. Fast, accurate, and reliable service available globally.",
      },
      {
        "@type": "WebPage",
        "@id": "https://www.tomedes.com/interpretation-services",
        url: "https://www.tomedes.com/interpretation-services",
        name: "Professional Interpretation Services - Tomedes",
        description:
          "Tomedes translation services provides high quality interpretation services, including simultaneous interpretation, consecutive interpretation and conference interpretation. We're available 24/7. Quality-guaranteed service.",
        inLanguage: "en",
        isPartOf: {
          "@type": "WebSite",
          "@id": "https://www.tomedes.com",
        },
        primaryImageOfPage: {
          "@type": "ImageObject",
          url: "https://tomedes.gumlet.io/frontend/images/tomedes-logo.jpg",
        },
      },
    ],
  };
  const ldJsonAll = {
    "@context": "https://schema.org/",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://www.tomedes.com/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Translation Services",
        item: "https://www.tomedes.com/translation-services",
      },
    ],
  };


  const ldJsonHub = {
    "@context": "https://schema.org",
    "@type": "Article",
    url: `${data.site.siteMetadata.siteUrl}${
      slug?.endsWith("/") ? slug?.slice(0, -1) : slug || ""
    }`,
    wordCount: wordCount,
    headline: title || data.site.siteMetadata.title,
    image: {
      "@type": "ImageObject",
      url: banner,
      width: "768px",
      height: "320px",
    },
    datePublished: moment(createdAt).format("YYYY-MM-DDThh:mm:ssZ"),
    dateModified: moment(modifiedAt).format("YYYY-MM-DDThh:mm:ssZ"),
    description: description,
    // identifier: "blog/link-building",
    publisher: {
      "@type": "Organization",
      name: "Tomedes Ltd",
      logo: {
        "@type": "ImageObject",
        url: "https://tomedes.gumlet.io/assets/images/Tomedes_Logo.svg?width=0",
        width: "156px",
        height: "32px",
      },
    },
    author: {
      "@type": "Person",
      name: author,
    },
    genre: genre,
  };

  // for homepage only
  const ldJsonPrimary = {
    "@context": "http://schema.org",
    "@type": "Organization",
    name: "Tomedes Ltd",
    description:
      "Professional translation services. Join over 95,000 businesses who enjoy 24/7 support, 1 year guarantee and competitive prices. Get your quote now!",
    image: "https://tomedes.gumlet.io/frontend/images/tomedes-logo.svg",
    url: "https://www.tomedes.com/",
    sameAs: [
      "https://www.facebook.com/Tomedes.translation",
      "https://twitter.com/Tomedes",
      "https://www.linkedin.com/company/tomedes.com",
      "https://www.youtube.com/channel/UC9k2By4XhHEjI6usn0nJfNw",
    ],
    logo: {
      "@type": "ImageObject",
      url: "https://tomedes.gumlet.io/frontend/images/tomedes-logo.jpg",
    },
    address: {
      "@type": "PostalAddress",
      streetAddress: "9450 SW Gemini Dr #34540,",
      addressLocality: "Beaverton",
      addressRegion: "OR",
      postalCode: "97008-7105",
      addressCountry: "United States",
    },
    email: "support@tomedes.com",
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "+1 985 239 0142",
      contactType: "Customer Service",
    },
  };
  const robotsContent = UpdatreshareId ? "noindex,follow" : "index,follow";

  return (
    <Helmet htmlAttributes={{ lang: `en-US` }}>
      <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
      <title>{title || data.site.siteMetadata.title}</title>
      <meta
        name="description"
        content={description || data.site.siteMetadata.description}
      />
      {slug === "/" ? (
        <link rel="canonical" href="https://www.tomedes.com/" />
      ) : (
        <link
          // hreflang="en-us"
          rel="canonical"
          href={`${data.site.siteMetadata.siteUrl}${
            slug?.endsWith("/") ? slug?.slice(0, -1) : slug || ""
          }`}
        />
      )}
      {slug?.includes("/translator-hub/") && (
        <script type="application/ld+json">
          {JSON.stringify(ldJosnBreadcrumbs)}
        </script>
      )}
  
      {slug?.includes("/interpretation-services") && (
        <script type="application/ld+json">
          {JSON.stringify(ldjsonInterpreting)}
        </script>
      )}

      {slug === "/translation-services" && (
        <script type="application/ld+json">{JSON.stringify(ldJsonAll)}</script>
      )}
  
      <script type="application/ld+json">
        {slug === "/"
          ? JSON.stringify(ldJsonPrimary)
          : slug?.includes("/translator-hub/")
          ? JSON.stringify(ldJsonHub)
          : scehema || JSON.stringify(ldJson)}
      </script>
      {/* <script src="https://www.googleoptimize.com/optimize.js?id=OPT-K73ZJXG"></script>*/}
      <meta name="keywords" content={keywords || ""} />
      <meta property="twitter:card" data-page-subject="true" value="summary" />
      <meta property="twitter:site" data-page-subject="true" value="@Tomedes" />
      <meta
        property="og:site_name"
        data-page-subject="true"
        content="Tomedes"
      />
      <meta property="og:locale" data-page-subject="true" content="en_US" />
      <meta
        property="og:title"
        data-page-subject="true"
        content={title || data.site.siteMetadata.title}
      />
      <meta
        property="og:keyword"
        data-page-subject="true"
        content={keywords || ""}
      />

      <meta property="robots" content={robotsContent} />

      <meta
        property="og:description"
        data-page-subject="true"
        content={description || data.site.siteMetadata.description}
      />
      <meta property="og:type" data-page-subject="true" content="article" />
      <meta
        content="https://www.facebook.com/Tomedes.translation"
        data-page-subject="true"
        property="og:article:publisher"
      />
      <meta
        property="og:url"
        data-page-subject="true"
        content={`${data.site.siteMetadata.siteUrl}${
          slug?.endsWith("/") ? slug?.slice(0, -1) : slug || ""
        }`}
      />
      {slug === "/" ? (
        <link
          rel="alternate"
          hreflang="en-us"
          href="https://www.tomedes.com/"
        />
      ) : (
        <link
          rel="alternate"
          hreflang="en-us"
          href={`${data.site.siteMetadata.siteUrl}${
            slug?.endsWith("/") ? slug?.slice(0, -1) : slug || ""
          }`}
        />
      )}

      <link rel="preconnect" href="https://dev.visualwebsiteoptimizer.com" />
      <script type="text/javascript" id="vwoCode">
        {`
          window._vwo_code || (function() {
            var account_id=783859,
            version=2.0,
            settings_tolerance=2000,
            hide_element='body',
            hide_element_style = 'opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important',
            /* DO NOT EDIT BELOW THIS LINE */
            f=false,w=window,d=document,v=d.querySelector('#vwoCode'),cK='_vwo_'+account_id+'_settings',cc={};try{var c=JSON.parse(localStorage.getItem('_vwo_'+account_id+'_config'));cc=c&&typeof c==='object'?c:{}}catch(e){}var stT=cc.stT==='session'?w.sessionStorage:w.localStorage;code={use_existing_jquery:function(){return typeof use_existing_jquery!=='undefined'?use_existing_jquery:undefined},library_tolerance:function(){return typeof library_tolerance!=='undefined'?library_tolerance:undefined},settings_tolerance:function(){return cc.sT||settings_tolerance},hide_element_style:function(){return'{'+(cc.hES||hide_element_style)+'}'},hide_element:function(){return typeof cc.hE==='string'?cc.hE:hide_element},getVersion:function(){return version},finish:function(){if(!f){f=true;var e=d.getElementById('_vis_opt_path_hides');if(e)e.parentNode.removeChild(e)}},finished:function(){return f},load:function(e){var t=this.getSettings(),n=d.createElement('script'),i=this;if(t){n.textContent=t;d.getElementsByTagName('head')[0].appendChild(n);if(!w.VWO||VWO.caE){stT.removeItem(cK);i.load(e)}}else{n.fetchPriority='high';n.src=e;n.type='text/javascript';n.onerror=function(){_vwo_code.finish()};d.getElementsByTagName('head')[0].appendChild(n)}},getSettings:function(){try{var e=stT.getItem(cK);if(!e){return}e=JSON.parse(e);if(Date.now()>e.e){stT.removeItem(cK);return}return e.s}catch(e){return}},init:function(){if(d.URL.indexOf('__vwo_disable__')>-1)return;var e=this.settings_tolerance();w._vwo_settings_timer=setTimeout(function(){_vwo_code.finish();stT.removeItem(cK)},e);var t=d.currentScript,n=d.createElement('style'),i=this;if(t&&!t.async){i.load('https://dev.visualwebsiteoptimizer.com/j.php?a='+account_id+'&u='+encodeURIComponent(d.URL)+'&vn='+version);return}n.setAttribute('id','_vis_opt_path_hides');v&&n.setAttribute('nonce',v.nonce);n.setAttribute('type','text/css');n.fetchPriority='high';if(n.styleSheet)n.styleSheet.cssText=i.hide_element()+i.hide_element_style();else n.appendChild(d.createTextNode(i.hide_element()+i.hide_element_style()));d.getElementsByTagName('head')[0].appendChild(n);this.load('https://dev.visualwebsiteoptimizer.com/j.php?a='+account_id+'&u='+encodeURIComponent(d.URL)+'&vn='+version)}};w._vwo_code=code;code.init();})();
        `}
      </script>
      {/* <script type="text/javascript" id="zsiqchat">
        {`var $zoho=$zoho || {};$zoho.salesiq = $zoho.salesiq || {widgetcode: "siqb876ca01cb38e8bab3e91df75cd6c0a03d88c1d8fe552ff300830d9f85f9f15c", values:{},ready:function(){}};var d=document;s=d.createElement("script");s.type="text/javascript";s.id="zsiqscript";s.defer=true;s.src="https://salesiq.zohopublic.com/widget";t=d.getElementsByTagName("script")[0];t.parentNode.insertBefore(s,t);`}
      </script> */}
      <script type="text/javascript" id="zsiqchat">
        {`
          window.$zoho = window.$zoho || {};
          $zoho.salesiq = $zoho.salesiq || { ready: function() {} };
        `}
      </script>
      <script
        id="zsiqscript"
        src="https://salesiq.zohopublic.com/widget?wc=siqb876ca01cb38e8bab3e91df75cd6c0a03d88c1d8fe552ff300830d9f85f9f15c"
        defer
      ></script>

      <script>
        {`
$zoho.salesiq.ready = function() {
     $zoho.salesiq.set("home.widgets", [
          {
               type : "announcement",
               data : {
                    title : "Improve Every Stage of Translation",
                    body : {
                         text : "Tomedes Free AI Tools streamline pre-translation, translation, and post-translation tasks. Save time and enhance accuracy at every step."
                    },
                    action : {
                         invoke : "open.url",
                         url : "https://www.tomedes.com/tools",
                         text : " Use the Tools Now",
                    }
               }
          }
     ]);
}
      `}
      </script>

      <script
        type="text/javascript"
        src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
        async
      ></script>
    </Helmet>
  );
};

export default SEO;
